import { captureGupReviewLink } from '@/lib/gup';
import { prepareGupEntry, type GupEntry } from '@/services/gup-entry';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/processes/$processInstanceId/')({
  validateSearch: (
    search,
  ): {
    from: 'task' | undefined;
    version: string | undefined;
    encRequest?: string;
    callbackUrl?: string;
    authMethod?: string;
    lang?: string;
    source?: string;
    crNumber?: string;
  } => ({
    from: search.from as 'task' | undefined,
    version: search.version as string | undefined,
    encRequest: search.encRequest === undefined ? undefined : String(search.encRequest),
    callbackUrl: typeof search.callbackUrl === 'string' ? search.callbackUrl : undefined,
    authMethod: typeof search.authMethod === 'string' ? search.authMethod : undefined,
    lang: typeof search.lang === 'string' ? search.lang : undefined,
    source: typeof search.source === 'string' ? search.source : undefined,
    crNumber:
      typeof search.crNumber === 'string'
        ? search.crNumber
        : typeof search.crnumber === 'string'
          ? search.crnumber
          : undefined,
  }),
  context: ({ params }) => {
    return {
      getBreadcrumbData: () => ({
        id: params.processInstanceId,
        translationKey: null,
      }),
    };
  },
  beforeLoad: async ({ location, search, params }) => {
    if (search.encRequest === undefined) {
      const visit = captureGupReviewLink(search, params.processInstanceId);
      const gupEntry: GupEntry | undefined = visit ? { visit } : undefined;
      return { gupEntry };
    }
    const gupEntry = await prepareGupEntry(location.pathname + location.searchStr, params.processInstanceId);
    if (gupEntry.login) throw redirect({ to: '/login', search: { redirect: location.pathname + location.searchStr } });
    if (gupEntry.registration)
      throw redirect({
        to: '/signup',
        search: { redirect: location.pathname + location.searchStr, txId: undefined, mpkId: undefined },
      });
    return { gupEntry };
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Application Details - OPAZ E-Service Portal',
        },
      ],
    };
  },
});
